var _path, _path2, _path3, _rect, _g, _path4, _path5, _path6, _path7, _path8, _rect2, _g2, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgServices = function SvgServices(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4031_94880)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45 90C69.8528 90 90 69.8528 90 45C90 20.1472 69.8528 0 45 0C20.1472 0 0 20.1472 0 45C0 69.8528 20.1472 90 45 90Z",
    fill: "#C9EFFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8984 24.7197L67.1553 26.9766L68.504 25.6279L66.2471 23.371L64.8984 24.7197Z",
    fill: "#058DE0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6048 23.0847L68.7929 26.2729C69.1643 26.6443 69.7664 26.6443 70.1377 26.2729L71.5888 24.8218C71.9602 24.4504 71.9602 23.8483 71.5888 23.477L68.4007 20.2888C68.0293 19.9174 67.4272 19.9175 67.0559 20.2888L65.6048 21.7399C65.2334 22.1113 65.2334 22.7134 65.6048 23.0847Z",
    fill: "#25BEEF",
    stroke: "#25BEEF",
    strokeWidth: 0.773318,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4031_94880",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 64,
    y: 21,
    width: 7,
    height: 7
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 64.8794,
    y: 21.8203,
    width: 7.25809,
    height: 0.8576,
    transform: "rotate(45 64.8794 21.8203)",
    fill: "#D9D9D9"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4031_94880)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.5667 23.198L68.7548 26.3862C69.1262 26.7575 69.7283 26.7575 70.0997 26.3862L71.5508 24.9351C71.9221 24.5637 71.9221 23.9616 71.5508 23.5903L68.3626 20.4021C67.9912 20.0307 67.3891 20.0307 67.0178 20.4021L65.5667 21.8532C65.1953 22.2246 65.1953 22.8267 65.5667 23.198Z",
    fill: "#25BEEF",
    stroke: "#25BEEF",
    strokeWidth: 0.773318,
    strokeMiterlimit: 10
  })))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2103 15.0234H41.8516V17.204H48.2103V15.0234Z",
    fill: "#058DE0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6616 8.26172H39.4007C38.9766 8.26172 38.6328 8.6055 38.6328 9.02957V14.2023C38.6328 14.6264 38.9766 14.9702 39.4007 14.9702H50.6616C51.0857 14.9702 51.4295 14.6264 51.4295 14.2023V9.02957C51.4295 8.6055 51.0857 8.26172 50.6616 8.26172Z",
    fill: "#25BEEF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6289 8.27734H39.3679C38.9439 8.27734 38.6001 8.62112 38.6001 9.0452V14.218C38.6001 14.642 38.9439 14.9858 39.3679 14.9858H50.6289C51.053 14.9858 51.3967 14.642 51.3967 14.218V9.0452C51.3967 8.62112 51.053 8.27734 50.6289 8.27734Z",
    fill: "#25BEEF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.4006 8.64832C39.1901 8.64832 39.0194 8.81898 39.0194 9.02951V14.2023C39.0194 14.4128 39.1901 14.5835 39.4006 14.5835H50.6615C50.8721 14.5835 51.0427 14.4128 51.0427 14.2023V9.02951C51.0427 8.81899 50.8721 8.64832 50.6615 8.64832H39.4006ZM38.2461 9.02951C38.2461 8.39189 38.763 7.875 39.4006 7.875H50.6615C51.2991 7.875 51.8161 8.39189 51.8161 9.02951V14.2023C51.8161 14.8399 51.2991 15.3568 50.6615 15.3568H39.4006C38.763 15.3568 38.2461 14.8399 38.2461 14.2023V9.02951Z",
    fill: "#25BEEF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.3679 8.66785C39.1574 8.66785 38.9867 8.83851 38.9867 9.04904V14.2218C38.9867 14.4323 39.1574 14.603 39.3679 14.603H50.6288C50.8394 14.603 51.01 14.4323 51.01 14.2218V9.04904C51.01 8.83852 50.8394 8.66785 50.6288 8.66785H39.3679ZM38.2134 9.04904C38.2134 8.41142 38.7303 7.89453 39.3679 7.89453H50.6288C51.2664 7.89453 51.7833 8.41142 51.7833 9.04904V14.2218C51.7833 14.8594 51.2664 15.3763 50.6288 15.3763H39.3679C38.7303 15.3763 38.2134 14.8594 38.2134 14.2218V9.04904Z",
    fill: "#25BEEF"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_4031_94880",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 38,
    y: 14,
    width: 14,
    height: 2
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 38.2134,
    y: 14.2812,
    width: 13.5282,
    height: 1.12735,
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_4031_94880)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.6606 8.28125H39.3997C38.9756 8.28125 38.6318 8.62503 38.6318 9.0491V14.2219C38.6318 14.6459 38.9756 14.9897 39.3997 14.9897H50.6606C51.0847 14.9897 51.4285 14.6459 51.4285 14.2219V9.0491C51.4285 8.62503 51.0847 8.28125 50.6606 8.28125Z",
    fill: "#25BEEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6284 8.29688H39.3675C38.9434 8.29688 38.5996 8.64065 38.5996 9.06473V14.2375C38.5996 14.6616 38.9434 15.0053 39.3675 15.0053H50.6284C51.0525 15.0053 51.3962 14.6616 51.3962 14.2375V9.06473C51.3962 8.64065 51.0525 8.29688 50.6284 8.29688Z",
    fill: "#25BEEF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.4001 8.66785C39.1896 8.66785 39.0189 8.83851 39.0189 9.04904V14.2218C39.0189 14.4323 39.1896 14.603 39.4001 14.603H50.661C50.8716 14.603 51.0422 14.4323 51.0422 14.2218V9.04904C51.0422 8.83852 50.8716 8.66785 50.661 8.66785H39.4001ZM38.2456 9.04904C38.2456 8.41142 38.7625 7.89453 39.4001 7.89453H50.661C51.2987 7.89453 51.8156 8.41142 51.8156 9.04904V14.2218C51.8156 14.8594 51.2987 15.3763 50.661 15.3763H39.4001C38.7625 15.3763 38.2456 14.8594 38.2456 14.2218V9.04904Z",
    fill: "#25BEEF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.3679 8.68738C39.1574 8.68738 38.9867 8.85805 38.9867 9.06857V14.2413C38.9867 14.4519 39.1574 14.6225 39.3679 14.6225H50.6288C50.8394 14.6225 51.01 14.4519 51.01 14.2413V9.06857C51.01 8.85805 50.8394 8.68738 50.6288 8.68738H39.3679ZM38.2134 9.06857C38.2134 8.43095 38.7303 7.91406 39.3679 7.91406H50.6288C51.2664 7.91406 51.7833 8.43095 51.7833 9.06857V14.2413C51.7833 14.879 51.2664 15.3958 50.6288 15.3958H39.3679C38.7303 15.3958 38.2134 14.879 38.2134 14.2413V9.06857Z",
    fill: "#25BEEF"
  })))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0868 75.4228C68.0515 71.5075 77.8193 55.3915 73.9039 39.4269C69.9885 23.4623 53.8726 13.6944 37.908 17.6098C21.9434 21.5252 12.1755 37.6411 16.0909 53.6057C20.0063 69.5704 36.1222 79.3382 52.0868 75.4228Z",
    fill: "#058DE0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2504 64.7752C73.3305 54.695 73.3305 38.3518 63.2504 28.2717C53.1702 18.1915 36.827 18.1915 26.7469 28.2717C16.6667 38.3518 16.6667 54.695 26.7469 64.7752C36.827 74.8553 53.1702 74.8554 63.2504 64.7752Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.458 72.2017C40.5897 71.7117 34.857 69.2216 30.3669 64.7316C20.2868 54.6514 20.2868 38.3083 30.3669 28.2281C34.857 23.7381 40.5897 21.248 46.458 20.758C39.1519 20.1479 31.6356 22.638 26.0455 28.2281C15.9653 38.3083 15.9653 54.6514 26.0455 64.7316C31.6356 70.3217 39.1519 72.8117 46.458 72.2017Z",
    fill: "#D0EAF9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0001 47.3678C45.4647 47.3678 45.8445 47.0371 45.8445 46.6272V30.0296C45.8445 29.6197 45.4674 29.2891 45.0001 29.2891C44.5329 29.2891 44.1558 29.6197 44.1558 30.0296V46.6272C44.1558 47.0371 44.5329 47.3678 45.0001 47.3678Z",
    fill: "#C9EFFB",
    stroke: "#C9EFFB",
    strokeWidth: 0.773318,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8126 59.0504C51.9492 59.0504 52.0858 59.0149 52.2115 58.9411C52.5914 58.7198 52.7198 58.2334 52.4985 57.8536L45.637 46.0789C45.4156 45.6991 44.9265 45.5706 44.5467 45.792C44.1669 46.0133 44.0384 46.4997 44.2598 46.8796L51.1185 58.6542C51.2661 58.9083 51.5339 59.0504 51.8071 59.0504H51.8126Z",
    fill: "#C9EFFB",
    stroke: "#C9EFFB",
    strokeWidth: 0.773318,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6807 46.5231C42.6807 47.8047 43.719 48.843 45.0006 48.843C46.2822 48.843 47.3206 47.8047 47.3206 46.5231C47.3206 45.2415 46.2822 44.2031 45.0006 44.2031C43.719 44.2031 42.6807 45.2415 42.6807 46.5231Z",
    fill: "#FFC513"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9999 25.3048C45.2322 25.3048 45.4207 25.1162 45.4207 24.884V22.3153C45.4207 22.0831 45.2322 21.8945 44.9999 21.8945C44.7677 21.8945 44.5791 22.0831 44.5791 22.3153V24.884C44.5791 25.1162 44.7677 25.3048 44.9999 25.3048Z",
    fill: "#058DE0"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9999 25.3048C45.2322 25.3048 45.4207 25.1162 45.4207 24.884V22.3153C45.4207 22.0831 45.2322 21.8945 44.9999 21.8945C44.7677 21.8945 44.5791 22.0831 44.5791 22.3153V24.884C44.5791 25.1162 44.7677 25.3048 44.9999 25.3048Z",
    stroke: "#058DE0",
    strokeWidth: 0.273257,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8183 28.2049C55.9631 28.2049 56.1052 28.1284 56.1844 27.9945L57.4687 25.7702C57.5862 25.568 57.5152 25.3111 57.3157 25.1936C57.1135 25.0761 56.8567 25.1472 56.7391 25.3466L55.4548 27.5709C55.3373 27.7732 55.4084 28.03 55.6079 28.1475C55.6734 28.1858 55.7472 28.2049 55.8183 28.2049Z",
    fill: "#058DE0"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8183 28.2049C55.9631 28.2049 56.1052 28.1284 56.1844 27.9945L57.4687 25.7702C57.5862 25.568 57.5152 25.3111 57.3157 25.1936C57.1135 25.0761 56.8567 25.1472 56.7391 25.3466L55.4548 27.5709C55.3373 27.7732 55.4084 28.03 55.6079 28.1475C55.6734 28.1858 55.7472 28.2049 55.8183 28.2049Z",
    stroke: "#058DE0",
    strokeWidth: 0.273257,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7376 36.1249C63.8087 36.1249 63.8824 36.1057 63.948 36.0675L66.1723 34.7832C66.3745 34.6657 66.4429 34.4088 66.3254 34.2066C66.2079 34.0044 65.951 33.9361 65.7488 34.0536L63.5245 35.3379C63.3223 35.4554 63.254 35.7123 63.3715 35.9145C63.4507 36.0484 63.5901 36.1249 63.7376 36.1249Z",
    fill: "#058DE0"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7376 36.1249C63.8087 36.1249 63.8824 36.1057 63.948 36.0675L66.1723 34.7832C66.3745 34.6657 66.4429 34.4088 66.3254 34.2066C66.2079 34.0044 65.951 33.9361 65.7488 34.0536L63.5245 35.3379C63.3223 35.4554 63.254 35.7123 63.3715 35.9145C63.4507 36.0484 63.5901 36.1249 63.7376 36.1249Z",
    stroke: "#058DE0",
    strokeWidth: 0.273257,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6362 46.9432H69.2048C69.437 46.9432 69.6256 46.7546 69.6256 46.5224C69.6256 46.2901 69.437 46.1016 69.2048 46.1016H66.6362C66.4039 46.1016 66.2153 46.2901 66.2153 46.5224C66.2153 46.7546 66.4039 46.9432 66.6362 46.9432Z",
    fill: "#058DE0"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6362 46.9432H69.2048C69.437 46.9432 69.6256 46.7546 69.6256 46.5224C69.6256 46.2901 69.437 46.1016 69.2048 46.1016H66.6362C66.4039 46.1016 66.2153 46.2901 66.2153 46.5224C66.2153 46.7546 66.4039 46.9432 66.6362 46.9432Z",
    stroke: "#058DE0",
    strokeWidth: 0.273257,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M65.961 59.0467C66.1059 59.0467 66.248 58.9702 66.3272 58.8363C66.4447 58.6341 66.3737 58.3773 66.1742 58.2598L63.9499 56.9755C63.7477 56.858 63.4908 56.9263 63.3733 57.1285C63.2558 57.3307 63.3268 57.5876 63.5263 57.7051L65.7506 58.9894C65.8162 59.0276 65.89 59.0467 65.961 59.0467Z",
    fill: "#058DE0"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M65.961 59.0467C66.1059 59.0467 66.248 58.9702 66.3272 58.8363C66.4447 58.6341 66.3737 58.3773 66.1742 58.2598L63.9499 56.9755C63.7477 56.858 63.4908 56.9263 63.3733 57.1285C63.2558 57.3307 63.3268 57.5876 63.5263 57.7051L65.7506 58.9894C65.8162 59.0276 65.89 59.0467 65.961 59.0467Z",
    stroke: "#058DE0",
    strokeWidth: 0.273257,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1025 67.9047C57.1735 67.9047 57.2473 67.8856 57.3129 67.8473C57.5151 67.7298 57.5834 67.473 57.4659 67.2708L56.1816 65.0464C56.0641 64.8442 55.8073 64.7759 55.605 64.8934C55.4028 65.0109 55.3345 65.2678 55.452 65.47L56.7363 67.6943C56.8156 67.8309 56.9549 67.9047 57.1025 67.9047Z",
    fill: "#058DE0"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1025 67.9047C57.1735 67.9047 57.2473 67.8856 57.3129 67.8473C57.5151 67.7298 57.5834 67.473 57.4659 67.2708L56.1816 65.0464C56.0641 64.8442 55.8073 64.7759 55.605 64.8934C55.4028 65.0109 55.3345 65.2678 55.452 65.47L56.7363 67.6943C56.8156 67.8309 56.9549 67.9047 57.1025 67.9047Z",
    stroke: "#058DE0",
    strokeWidth: 0.273257,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0004 71.1485C45.2327 71.1485 45.4212 70.96 45.4212 70.7277V68.1591C45.4212 67.9268 45.2327 67.7383 45.0004 67.7383C44.7681 67.7383 44.5796 67.9268 44.5796 68.1591V70.7277C44.5796 70.96 44.7681 71.1485 45.0004 71.1485Z",
    fill: "#058DE0"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0004 71.1485C45.2327 71.1485 45.4212 70.96 45.4212 70.7277V68.1591C45.4212 67.9268 45.2327 67.7383 45.0004 67.7383C44.7681 67.7383 44.5796 67.9268 44.5796 68.1591V70.7277C44.5796 70.96 44.7681 71.1485 45.0004 71.1485Z",
    stroke: "#058DE0",
    strokeWidth: 0.273257,
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8944 67.908C33.0393 67.908 33.1814 67.8315 33.2606 67.6976L34.5449 65.4733C34.6624 65.2711 34.5914 65.0142 34.3919 64.8967C34.1897 64.7792 33.9328 64.8503 33.8153 65.0498L32.531 67.2741C32.4135 67.4763 32.4846 67.7331 32.684 67.8506C32.7496 67.8889 32.8234 67.908 32.8944 67.908Z",
    fill: "#058DE0"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8944 67.908C33.0393 67.908 33.1814 67.8315 33.2606 67.6976L34.5449 65.4733C34.6624 65.2711 34.5914 65.0142 34.3919 64.8967C34.1897 64.7792 33.9328 64.8503 33.8153 65.0498L32.531 67.2741C32.4135 67.4763 32.4846 67.7331 32.684 67.8506C32.7496 67.8889 32.8234 67.908 32.8944 67.908Z",
    stroke: "#058DE0",
    strokeWidth: 0.273257,
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0355 59.0467C24.1065 59.0467 24.1803 59.0276 24.2459 58.9894L26.4702 57.7051C26.6724 57.5876 26.7407 57.3307 26.6232 57.1285C26.5057 56.9263 26.2489 56.858 26.0466 56.9755L23.8223 58.2598C23.6201 58.3773 23.5518 58.6341 23.6693 58.8363C23.7485 58.973 23.8879 59.0467 24.0355 59.0467Z",
    fill: "#058DE0"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0355 59.0467C24.1065 59.0467 24.1803 59.0276 24.2459 58.9894L26.4702 57.7051C26.6724 57.5876 26.7407 57.3307 26.6232 57.1285C26.5057 56.9263 26.2489 56.858 26.0466 56.9755L23.8223 58.2598C23.6201 58.3773 23.5518 58.6341 23.6693 58.8363C23.7485 58.973 23.8879 59.0467 24.0355 59.0467Z",
    stroke: "#058DE0",
    strokeWidth: 0.273257,
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7919 46.9432H23.3605C23.5928 46.9432 23.7813 46.7546 23.7813 46.5224C23.7813 46.2901 23.5928 46.1016 23.3605 46.1016H20.7919C20.5596 46.1016 20.3711 46.2901 20.3711 46.5224C20.3711 46.7546 20.5596 46.9432 20.7919 46.9432Z",
    fill: "#058DE0"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7919 46.9432H23.3605C23.5928 46.9432 23.7813 46.7546 23.7813 46.5224C23.7813 46.2901 23.5928 46.1016 23.3605 46.1016H20.7919C20.5596 46.1016 20.3711 46.2901 20.3711 46.5224C20.3711 46.7546 20.5596 46.9432 20.7919 46.9432Z",
    stroke: "#058DE0",
    strokeWidth: 0.273257,
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2599 36.1282C26.4047 36.1282 26.5468 36.0517 26.626 35.9178C26.7435 35.7156 26.6725 35.4587 26.473 35.3412L24.2487 34.0569C24.0465 33.9394 23.7896 34.0104 23.6721 34.2099C23.5546 34.4121 23.6257 34.669 23.8251 34.7865L26.0495 36.0708C26.115 36.1091 26.1888 36.1282 26.2599 36.1282Z",
    fill: "#058DE0"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2599 36.1282C26.4047 36.1282 26.5468 36.0517 26.626 35.9178C26.7435 35.7156 26.6725 35.4587 26.473 35.3412L24.2487 34.0569C24.0465 33.9394 23.7896 34.0104 23.6721 34.2099C23.5546 34.4121 23.6257 34.669 23.8251 34.7865L26.0495 36.0708C26.115 36.1091 26.1888 36.1282 26.2599 36.1282Z",
    stroke: "#058DE0",
    strokeWidth: 0.273257,
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1821 28.2055C34.2531 28.2055 34.3269 28.1864 34.3925 28.1481C34.5947 28.0306 34.663 27.7738 34.5455 27.5715L33.2612 25.3472C33.1437 25.145 32.8868 25.0767 32.6846 25.1942C32.4824 25.3117 32.4141 25.5686 32.5316 25.7708L33.8159 27.9951C33.8952 28.129 34.0345 28.2055 34.1821 28.2055Z",
    fill: "#058DE0",
    stroke: "#6C97CF",
    strokeWidth: 0.273257,
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M84.2941 64.6656C84.2941 70.094 76.1364 82.9042 73.3652 87.0993C72.9289 87.7598 71.9844 87.7598 71.5481 87.0993C68.7768 82.9042 60.6191 70.094 60.6191 64.6656C60.6191 58.1266 65.9203 52.8281 72.4566 52.8281C78.993 52.8281 84.2941 58.1293 84.2941 64.6656Z",
    fill: "#E2383E"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4566 69.7091C75.5292 69.7091 78.0201 67.2182 78.0201 64.1455C78.0201 61.0729 75.5292 58.582 72.4566 58.582C69.3839 58.582 66.8931 61.0729 66.8931 64.1455C66.8931 67.2182 69.3839 69.7091 72.4566 69.7091Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4031_94880"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 90,
    fill: "white"
  })))));
};
export default SvgServices;